module.exports = __webpack_public_path__ + "static/media/icons_Bilan Lymphoed確e.267fd782.svg";